import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-cf-number",
  "use": "icon-cf-number-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-cf-number\">\n<rect x=\"5\" y=\"5\" width=\"14\" height=\"14\" rx=\"1\" stroke=\"currentColor\" stroke-width=\"2\" />\n<path d=\"M11.8535 16V9.21484H11.748L9.67383 10.6562V9.0625L11.8594 7.54492H13.623V16H11.8535Z\" fill=\"currentColor\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol